export function prezzoInCentesimiToString(prezzoInCentesimi: number): string {
  const prezzoInCentesimiInt = Math.round(prezzoInCentesimi);
  const euro = Math.floor(prezzoInCentesimiInt / 100);
  const centesimi = prezzoInCentesimiInt % 100;
  const centesimiStr = centesimi >= 10 ? centesimi.toString() : `0${centesimi}`;
  return `${euro},${centesimiStr} €`;
}
